import React from 'react';

import { Animation } from 'shared/presentation/components/atoms';
import { useLocale } from 'shared/presentation/contexts';

import facialAnimation from './assets/facial_recognition.json';
import * as S from './styles';

const PendingStatus: React.FC = () => {
  const { t } = useLocale('shared');

  return (
    <S.Container>
      <div>
        <Animation
          loop
          animation={{
            data: facialAnimation,
            height: 150,
            width: 150,
          }}
        />
      </div>

      <p>{t('Wait while we verify your identity')}</p>
    </S.Container>
  );
};

export default PendingStatus;
